export default {
  hi_im_neela: 'Hi, I’m Neela,',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'Русский',
  spanish: 'Español',
  italian: 'Italiano',
  arabic: 'عربي',
  polish: 'Polska',
  aareons_virtual: 'Aareon’s Virtual Assistant.',
  media: 'Media',
  media_link: 'https://neela.aareon.com/media',
  contact: 'Contact',
  contact_link: 'https://neela.aareon.com/contact',
  privacy: 'Privacy',
  privacy_link: 'https://www.aareon.com/sixcms/detail.php/3627',
  terms_of_use: 'Terms of Use',
  terms_of_use_link: 'https://www.aareon.com/sixcms/detail.php/3621',
  legal_notice: 'Legal Notice',
  legal_notice_link: 'https://neela.aareon.com/legal',
  show_system_messages: 'Show system messages',
  dont_show_system_messages: 'Hide system messages',
  logged_in: 'Tenant is authenticated',
  logged_out: 'Anonymous user',
  button_switch_locale: 'Change language',
  button_tooltip_activate_voice_recognition: 'Activate voice recognition',
  date_input: 'Select date',
  choose_two_dates: 'Please select two dates',
  date_range: 'Date range',
  from: 'from',
  to: 'to',
  avatar: 'Avatar',
  exit: 'Exit',
  new: 'New',
  back: 'Back',
  suggestions: 'Suggestions',
  senton: 'Sent on',
  message_placeholder: 'Enter message here',
  comment_placeholder: 'Enter comment here',
  file_max_upload_text: 'A maximum of 20 files can be uploaded',
  message_button_label: 'Send',
  please_confirm: 'Please confirm',
  no: 'No',
  yes: 'Yes',
  modal_delete_session: 'Delete session',
  modal_delete_session_notification:
    'If you close the window, your session will also be deleted.<br>Are you okay with that?',
  template_contact_time: 'When can we contact you?',
  template_pause:
    'Your session has been paused. One of our support staff will take care of your request shortly.',
  template_continue_after_pause:
    'Your session has continued. You can now continue writing with our chatbot.',
  button_apply: 'Apply',
  button_cancel: 'Cancel',
  none: 'None',
  book_appointment: 'Book Appointment',
  address_input: 'Address input',
  data_processing: 'Data processing',
  privacy_policy: 'privacy policy',
  data_processing_notification_before_link:
    'To use this chat service it is necessary that you accept the ',
  data_processing_notification_after_link: '.',
  button_accept: 'Accept',
  select_date: 'Select Date',
  rate_conversation: 'How would you rate this conversation?',
  new_ticket_question: 'Is there anything else I can help you with?',
  thank_you:
    'Thank you for your support. Your feedback helps me to constantly improve myself.',
  goodbye: 'Goodbye.',
  start_new: 'Start new conversation',
  operator_entered_the_chat: 'Operator entered the chat',
  operator_left_the_chat: 'Operator has left the chat',
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'More',
  collapse_quickreplies: 'Less',
  login: 'Log in',
  logout: 'Log out',
  close: 'Close',
  upload_file: 'Drop files anywhere to upload',
  upload_file_or: 'or',
  Upload_file_select: 'Add files',
  upload_file_text: 'Drop files to upload',
  show_attachments: 'Show attachment',
  hide_attachments: 'Hide attachment',
  maximize: 'Maximize',
  minimize: 'Minimize',
  feedback_helpful: 'This answer helped me',
  feedback_not_helpful: "This answer didn't help me",
  chatProtocol: 'ChatProtocol',
  showMore: 'Show more',
  showLess: 'Show less',
  uploadTooltip: 'Upload file',
  uploadFilesTooltip: 'Upload files',
  pdfDownloadTooltip: 'Download Conversation',
  feedbackDescription: 'Feedback',
  feedbackSubtitle: {
    description:
      'Here you can send us general suggestions, proposals and requests.',
    note: 'Please note that we cannot respond to them.',
    hint:
      'All other concerns that specifically relate to your tenancy or the search for an apartment can be described to us in the chat.'
  },
  feedbackPlaceholder: 'Enter your message here...',
  sendFeedback: 'Submit',
  giveFeedback: 'Feedback',
  feedbackSubmittedSuccessfully: 'Your feedback was successfully submitted',
  thanks: 'Thank you'
}
